import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import apiClient from "../api/Api.js";
import { DataContext } from "../context/dataprovider.js";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData, role } = useContext(DataContext);
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const response = await apiClient.get(
          `${process.env.REACT_APP_AUTH_API}/verify`
        );
        setIsAuthenticated(response.status !== 400);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    verifyAuth();
  }, []);

  useEffect(() => {
    if (isAuthenticated === false) {
      navigate("/");
    }

    if (isAuthenticated && location.pathname === "/administrator-dashboard") {
      if (userData.role === role.roles_6) {
        navigate("/administrator-dashboard");
      } else {
        navigate("/transactions");
      }
    }

    if (isAuthenticated && userData.role === role.roles_6) {
      if (location.pathname !== "/administrator-dashboard") {
        navigate("/administrator-dashboard");
      }
    }
  }, [isAuthenticated, userData, location.pathname, navigate, role]);

  if (isAuthenticated === null) {
    return null; // or a loading spinner
  }

  return children;
};

export default ProtectedRoute;
